import { EndpointEnumerator } from './endpoint-enumerator';

export class ExportFormatEnum extends EndpointEnumerator{
    constructor(){
        super({
            json: 0,
            blob: 1
        });
    }
}



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/types/export-format.enum.js